import { Row, RenderConfig, TextInput, TextAreaInput } from 'commons-ui';
import * as yup from 'yup';
import { FEATURE_SEGMENTS_DESC_MIN_LENGTH } from './utils/constants';

export const FORM_FIELD_KEYS = {
	FEATURE_NAME: 'name',
	DESCRIPTION: 'description',
	FEATURE_ID: 'featureId',
	UPDATED_BY: 'updatedBy',
	UPDATED_AT: 'updatedAt',
	CREATED_BY: 'createdBy',
	CREATED_AT: 'createdAt',
	SEGMENT_NAMES: 'segmentNames'
};

export const FORM_FIELD_LABELS = {
	[FORM_FIELD_KEYS.FEATURE_NAME]: 'Feature Name',
	[FORM_FIELD_KEYS.DESCRIPTION]: 'Description',
	[FORM_FIELD_KEYS.FEATURE_ID]: 'Feature Id',
	[FORM_FIELD_KEYS.UPDATED_AT]: 'Updated At',
	[FORM_FIELD_KEYS.UPDATED_BY]: 'Updated By',
	[FORM_FIELD_KEYS.CREATED_AT]: 'Created At',
	[FORM_FIELD_KEYS.CREATED_BY]: 'Created By',
	[FORM_FIELD_KEYS.SEGMENT_NAMES]: 'Segments'
};

export const createPlatformFeatureValidationSchema = yup.object().shape({
	name: yup.string().required('Feature Name is a required field'),
	description: yup
		.string()
		.required('Description is a required field')
		.min(FEATURE_SEGMENTS_DESC_MIN_LENGTH, `description must be at least ${FEATURE_SEGMENTS_DESC_MIN_LENGTH} characters long`)
});

export const editPlatformFeatureValidationSchema = yup.object().shape({
	description: yup
		.string()
		.required('Description is a required field')
		.min(FEATURE_SEGMENTS_DESC_MIN_LENGTH, `description must be at least ${FEATURE_SEGMENTS_DESC_MIN_LENGTH} characters long`)
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.FEATURE_NAME]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.FEATURE_NAME)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.FEATURE_NAME])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.DESCRIPTION]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.DESCRIPTION)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.DESCRIPTION])
		.setRenderer(TextAreaInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.FEATURE_ID]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.FEATURE_ID)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.FEATURE_ID])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true
		})
};

export const EDIT_FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.FEATURE_NAME]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.FEATURE_NAME)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.FEATURE_NAME])
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: false, edit: false, view: false }, required: true }),
	[FORM_FIELD_KEYS.DESCRIPTION]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.DESCRIPTION)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.DESCRIPTION])
		.setRenderer(TextAreaInput)
		.setRenderProps({ isEditable: { create: false, edit: true, view: false }, required: true }),
	[FORM_FIELD_KEYS.FEATURE_ID]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.FEATURE_ID)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.FEATURE_ID])
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: false, edit: false, view: false }, required: true }),
	[FORM_FIELD_KEYS.SEGMENT_NAMES]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.SEGMENT_NAMES)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.SEGMENT_NAMES])
		.setRenderer(TextAreaInput)
		.setRenderProps({ isEditable: { create: false, edit: false, view: false }, required: false })
};

export const FORM_LAYOUT_CONFIG = [new Row(FORM_FIELD_KEYS.FEATURE_NAME), new Row(FORM_FIELD_KEYS.DESCRIPTION)];

export const EDIT_FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.FEATURE_NAME),
	new Row(FORM_FIELD_KEYS.DESCRIPTION),
	new Row(FORM_FIELD_KEYS.FEATURE_ID)
];

export const VIEW_FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.FEATURE_NAME),
	new Row(FORM_FIELD_KEYS.DESCRIPTION),
	new Row(FORM_FIELD_KEYS.FEATURE_ID),
	new Row(FORM_FIELD_KEYS.SEGMENT_NAMES)
];
